import 'regenerator-runtime';
import { put } from 'redux-saga/effects';
import {
    GET_PRICES_FOR_ITEMS_SUCCESS,
    GET_PRICES_FOR_ITEMS_FAILURE,
} from '../actions/actionTypes';
import { convertObjectToQueryParams, updateCurrencyCode } from 'src/utils/util';
import { getPricesForItemsDataService } from 'src/pages/consignmentAdd/services';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

const getParams = ({ products, orderType, sapPartnerId, bundleProducts }) => {
    const salesOrgList = [];
    products &&
        products.forEach((product) => {
            product.productCFN
                ? salesOrgList.push(product.productCFN)
                : salesOrgList.push(product.cfn);
        }); 
    return convertObjectToQueryParams({
        productCFN: salesOrgList.join(),
        sapPartnerId,
        orderType,
        bundleProducts,
    });
};

export default function* getPricesForconsignmentAddItemSaga(action) {
    try {
        const response = yield getPricesForItemsDataService(
            getParams(action.payload)
            // convertObjectToQueryParams(action.payload)
        );
        localStorage.setItem('currencyISOCode', response.priceDetails[0]?.currencyISOCode);
        updateCurrencyCode(response.priceDetails[0]?.currencyISOCode);
        yield put({
            type: GET_PRICES_FOR_ITEMS_SUCCESS,
            payload: {
                items: response.priceDetails,
                isPricingDone: true,
            },
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `occ/v2/${localStorage.getItem('baseSiteId')}/order/usage/price`,
            requestPayload: action.payload
        });
        yield put({
            type: GET_PRICES_FOR_ITEMS_FAILURE,
            payload: { items: [], isPricingDone: false },
        });
    }
}
